
import { container } from 'op/container';
import { compose, withState, withHandlers } from 'recompose';

import { withLocaleModification } from 'op/components/locale';
import { withOnlineStatus } from 'op/components/offline';

export const withSettingsModel = compose(
	withLocaleModification,
	withOnlineStatus,
	withState('openModal', 'setOpenModal', false),
	withHandlers({
		clearLocalData: ({ goTo, setOpenModal }) => async (url) => {
			await container.resolve('persistor').purge();
			window.location.reload();
		},
	}),
);
